/**
 * メタ情報を管理する
 */
export const META = {
  HEAD: {
    TITLE: 'DX 文書管理システム',
    DESCRIPTION: ''
  }
};
